
import type { PropType } from 'vue'
import type { PreTripDetailsRescheduleHistoryItem } from '@/core/types/tms-graph.types'

import { defineComponent } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<PreTripDetailsRescheduleHistoryItem>,
            required: true,
        }
    },
    components: {
        TheButton
    },
    emits: ['update-comment'],
    setup(props, { emit }) {
        const onUpdateComment = () => {
            emit('update-comment', { ...props.item })
        }

        return {
            onUpdateComment
        }
    }
})
